export let LAYOUT_STYLE_VALUES = /*#__PURE__*/function (LAYOUT_STYLE_VALUES) {
  LAYOUT_STYLE_VALUES[LAYOUT_STYLE_VALUES["SQUARE"] = 1] = "SQUARE";
  LAYOUT_STYLE_VALUES[LAYOUT_STYLE_VALUES["ROUND"] = 2] = "ROUND";
  return LAYOUT_STYLE_VALUES;
}({});
//# sourceMappingURL=layout-style-values.js.map